import React, { Component } from "react";
import "../style/ForgotPassword.css";
import axios from "axios";

class ForgotPasswordContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      formFeedback: null
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleInputChange(e) {
    const { value, name } = e.target;
    this.setState({ [name]: value });
  }
  async handleSubmit(e) {
    e.preventDefault();
    const { email } = this.state;
    const url =
      "https://qeyrfqi5id.execute-api.us-east-1.amazonaws.com/dev/users/password-reset";
    const data = {
      email
    };
    try {
      await axios.post(url, data);
      this.setState({
        formFeedback: "Alrighty, we just sent an email!"
      });
    } catch (error) {
      console.error(error.response);
      this.setState({
        formFeedback: "Something went wrong on our end"
      });
    }
  }
  render() {
    return (
      <div>
        {this.state.formFeedback && (
          <p style={{ marginLeft: "2rem" }}>{this.state.formFeedback}</p>
        )}

        <div className="forgot-password-container">
          <form onSubmit={this.handleSubmit}>
            <input
              className="sign-input"
              onChange={this.handleInputChange}
              type="email"
              name="email"
              placeholder="What's your email?"
            />
            <button className="btn" type="submit">
              Reset my password
            </button>
          </form>
        </div>
      </div>
    );
  }
}

export default ForgotPasswordContainer;



// WEBPACK FOOTER //
// ./src/components/ForgotPasswordContainer.js